import cn from 'classnames';
import React from 'react';

import s from './CircularProgress.module.scss';

type Props = React.SVGProps<SVGSVGElement>;

export const CircularProgressLarge = (props: Props): JSX.Element => {
  const { className, ...restProps } = props;

  return (
    <svg
      className={cn(s.loader, className)}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M57.0002 30C58.6571 30 60.0158 31.3465 59.8504 32.9951C59.3612 37.8703 57.6833 42.5679 54.9443 46.6671C51.6479 51.6006 46.9625 55.4458 41.4807 57.7164C35.9989 59.987 29.9668 60.5811 24.1474 59.4236C18.3279 58.266 12.9824 55.4088 8.78683 51.2132C4.59124 47.0176 1.73401 41.6721 0.576444 35.8527C-0.581117 30.0333 0.0129851 24.0013 2.28362 18.5195C4.55426 13.0377 8.39945 8.35235 13.3329 5.05591C17.4322 2.3169 22.1298 0.63901 27.005 0.149863C28.6536 -0.0155442 30.0001 1.34315 30.0001 3C30.0001 4.65685 28.6518 5.98067 27.0079 6.18725C23.3214 6.65048 19.7783 7.96539 16.6664 10.0447C12.7196 12.6819 9.64343 16.4302 7.82692 20.8156C6.01041 25.201 5.53513 30.0266 6.46118 34.6822C7.38723 39.3377 9.67301 43.6141 13.0295 46.9706C16.386 50.327 20.6624 52.6128 25.3179 53.5388C29.9735 54.4649 34.7991 53.9896 39.1846 52.1731C43.57 50.3566 47.3183 47.2805 49.9555 43.3337C52.0348 40.2217 53.3497 36.6787 53.813 32.9923C54.0195 31.3483 55.3434 30 57.0002 30Z"
        fill="url(#paint0_linear_517_9018)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_517_9018"
          x1="70.3128"
          y1="20.8126"
          x2="26.0626"
          y2="3.80885e-08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF3FD" stopOpacity="0" />
          <stop offset="0.555516" stopColor="#9DC0EC" stopOpacity="0.31" />
          <stop offset="1" stopColor="var(--loader-spinner-color)" />
        </linearGradient>
      </defs>
    </svg>
  );
};
